/* Fenêtre « Combien de Go choisir ? » : jours, usage, ce qui compte, puis le pack conseillé.
   Les packs et les prix viennent de window.WR_PACKS (product-main-content), les textes de #wr-dh-i18n. */
(()=>{
 const I={
 chat:'<svg viewBox="0 0 24 24"><path class="f" d="M19.5 11.2a7 7 0 0 1-10.2 6.2L5 18.6l1.2-3.8a7 7 0 1 1 13.3-3.6Z" opacity=".55"/><path d="M19.5 11.2a7 7 0 0 1-10.2 6.2L5 18.6l1.2-3.8a7 7 0 1 1 13.3-3.6Z"/><path d="M9.2 11.3h.01M12.5 11.3h.01M15.8 11.3h.01" stroke-width="2.4"/></svg>',
 social:'<svg viewBox="0 0 24 24"><rect class="f" x="4" y="4" width="16" height="16" rx="5" opacity=".55"/><rect x="4" y="4" width="16" height="16" rx="5"/><circle cx="12" cy="12" r="3.6"/><path d="M16.6 7.4h.01" stroke-width="2.4"/></svg>',
 video:'<svg viewBox="0 0 24 24"><rect class="f" x="2.8" y="5.5" width="13.4" height="13" rx="3.2" opacity=".55"/><rect x="2.8" y="5.5" width="13.4" height="13" rx="3.2"/><path d="m16.2 10.2 4.6-2.7v9l-4.6-2.7"/><path d="m8 9.6 3.8 2.4L8 14.4Z" fill="#35501a" stroke-width="1.2"/></svg>',
 piggy:'<svg viewBox="0 0 24 24"><path class="f" d="M5.5 11.5c0-3.4 3-5.8 6.8-5.8 3 0 5.3 1.3 6.3 3.4l1.9.3v4.1l-1.8.6a6.4 6.4 0 0 1-2.2 2.7V19h-2.8l-.5-1.4c-.6.1-1.2.1-1.8 0L10.9 19H8.1v-2.3a5.8 5.8 0 0 1-2.6-5.2Z" opacity=".55"/><path d="M5.5 11.5c0-3.4 3-5.8 6.8-5.8 3 0 5.3 1.3 6.3 3.4l1.9.3v4.1l-1.8.6a6.4 6.4 0 0 1-2.2 2.7V19h-2.8l-.5-1.4c-.6.1-1.2.1-1.8 0L10.9 19H8.1v-2.3a5.8 5.8 0 0 1-2.6-5.2Z"/><path d="M5.5 11.2C4 11 3.2 10 3.4 8.8M10.3 8.6h3.6M16.3 10.4h.01" stroke-width="1.7"/></svg>',
 shield:'<svg viewBox="0 0 24 24"><path class="f" d="M12 3.2 5.2 6v5.4c0 4.2 2.9 7.5 6.8 9.4 3.9-1.9 6.8-5.2 6.8-9.4V6Z" opacity=".55"/><path d="M12 3.2 5.2 6v5.4c0 4.2 2.9 7.5 6.8 9.4 3.9-1.9 6.8-5.2 6.8-9.4V6Z"/><path d="m9 12.1 2.1 2.1 4-4.2" stroke-width="1.9"/></svg>',
 inf:'<svg viewBox="0 0 24 24"><path d="M12 12c-1.7-2.1-2.9-3.4-4.6-3.4a3.4 3.4 0 0 0 0 6.8c1.7 0 2.9-1.3 4.6-3.4s2.9-3.4 4.6-3.4a3.4 3.4 0 0 1 0 6.8c-1.7 0-2.9-1.3-4.6-3.4Z" stroke-width="1.9"/></svg>'
};
 const RATE={light:0.5,normal:1,heavy:2.5};
 const MARGIN=1.6;
 const MAX_DAYS=30;

 function init(){
  const dialog=document.getElementById('wr-datahelp');
  if(!dialog||dialog.dataset.wrReady)return;
  const packs=window.WR_PACKS;
  const triggers=document.querySelectorAll('[data-wr-datahelp-open]');
  // Sans packs à volume (produit 100 % illimité), la question ne se pose pas.
  if(!packs||!packs.limited||!packs.limited.length){triggers.forEach(t=>t.hidden=true);return;}
  dialog.dataset.wrReady='true';

  let T={};
  try{T=JSON.parse(document.getElementById('wr-dh-i18n').textContent)}catch(e){}
  /* Shopify refuse les textes de plus de 1000 caractères : les libellés sont répartis sur deux clés */
  try{Object.assign(T,JSON.parse(document.getElementById('wr-dh-i18n-2').textContent))}catch(e){}
  const t=(k,o)=>String(T[k]==null?k:T[k]).replace(/\{(\w+)\}/g,(m,x)=>o&&o[x]!=null?o[x]:m);
  const esc=v=>String(v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  const dayWord=n=>n+' '+t(n>1?'days':'day');
  const money=n=>packs.format(n);

  const $=s=>dialog.querySelector(s);
  const body=$('#wr-dh-body'),q=$('#wr-dh-q'),eyebrow=$('#wr-dh-step'),back=$('[data-wr-dh-back]');
  const bars=dialog.querySelectorAll('.wr-dh-prog i');
  back.setAttribute('aria-label',t('back'));
  const S={i:0,days:7,use:'normal',prio:null};

  /* ---- packs ---- */
  const packDays=p=>parseInt(String(p.sub||'').replace(/[^0-9]/g,''),10)||9999;
  const asLim=p=>({id:p.id,price:p.price,label:p.label,days:packDays(p),gb:p.gb,key:'l'+p.id});
  function validFor(days){
   return packs.limited.filter(p=>packDays(p)>=days&&p.gb>0).slice().sort((a,b)=>a.gb-b.gb||a.price-b.price).map(asLim);
  }
  function unlFor(days){
   const u=(packs.unlimited||[]).slice().sort((a,b)=>a.days-b.days);
   if(!u.length)return null;
   const e=u.find(x=>x.days>=days)||u[u.length-1];
   return {unl:true,id:e.id,price:e.price,days:e.days,label:packs.unlimitedName?packs.unlimitedName():'Unlimited',key:'u'+e.days};
  }
  function tiers(days,rate){
   const list=validFor(days),free=unlFor(days),biggest=list[list.length-1]||null;
   const fit=need=>list.find(p=>p.gb>=need)||null;
   const eco=fit(days*rate)||free||biggest;
   let calm=fit(days*rate*MARGIN)||free||biggest;
   if(calm&&!calm.unl&&free&&calm.price>=free.price)calm=free;
   if(eco&&calm&&eco.key===calm.key&&!eco.unl){
    const n=list[list.findIndex(p=>p.key===eco.key)+1];
    calm=n&&(!free||n.price<free.price)?n:(free||eco);
   }
   return {eco,calm,free};
  }

  /* ---- écrans ---- */
  function hint(d){
   if(d>=30)return t('month');
   if(d<=3)return t('short');
   if(d<7)return t('under_week');
   const w=Math.floor(d/7),r=d%7,wk=w===1?'1 '+t('week'):w+' '+t('weeks');
   return r?t('and',{a:wk,b:dayWord(r)}):wk;
  }
  function step1(){
   const ticks=[1,7,14,21,30].map(v=>'<span style="left:'+((v-1)/(MAX_DAYS-1)*100)+'%">'+v+'</span>').join('');
   body.innerHTML='<div class="wr-dh-gv"><button type="button" class="wr-dh-rnd" data-d="-1" aria-label="'+esc(t('less'))+'">−</button>'+
    '<output class="wr-dh-gn" aria-live="polite"><b></b><span></span></output>'+
    '<button type="button" class="wr-dh-rnd" data-d="1" aria-label="'+esc(t('more'))+'">+</button></div>'+
    '<input class="wr-dh-range" type="range" min="1" max="'+MAX_DAYS+'" step="1" aria-label="'+esc(t('days_label'))+'">'+
    '<div class="wr-dh-ticks" aria-hidden="true">'+ticks+'</div><p class="wr-dh-hint"></p>'+
    '<button type="button" class="wr-dh-cta" data-next>'+esc(t('continue'))+'</button>';
   const r=body.querySelector('.wr-dh-range'),n=body.querySelector('.wr-dh-gn b'),u=body.querySelector('.wr-dh-gn span'),h=body.querySelector('.wr-dh-hint');
   const minus=body.querySelector('[data-d="-1"]'),plus=body.querySelector('[data-d="1"]');
   const set=v=>{
    v=Math.max(1,Math.min(MAX_DAYS,v));S.days=v;r.value=v;n.textContent=v;u.textContent=t(v>1?'days':'day');
    r.style.setProperty('--p',((v-1)/(MAX_DAYS-1)*100)+'%');h.textContent=hint(v);
    minus.disabled=v<=1;plus.disabled=v>=MAX_DAYS;
   };
   r.addEventListener('input',()=>set(+r.value));
   minus.addEventListener('click',()=>set(S.days-1));
   plus.addEventListener('click',()=>set(S.days+1));
   body.querySelector('[data-next]').addEventListener('click',()=>show(1));
   set(S.days);
  }
  function option(attr,icon,dark,title,sub,right,star){
   return '<button type="button" class="wr-dh-opt'+(star?' star':'')+'" '+attr+'>'+(star?'<span class="wr-dh-flag">'+esc(t('flag'))+'</span>':'')+
    '<span class="wr-dh-ic'+(dark?' dark':'')+'" aria-hidden="true">'+I[icon]+'</span><div><b>'+esc(title)+'</b><p>'+esc(sub)+'</p></div>'+(right||'')+'</button>';
  }
  function step2(){
   body.innerHTML='<div class="wr-dh-opts">'+
    option('data-use="light"','chat',0,t('light_t'),t('light_s'))+
    option('data-use="normal"','social',0,t('normal_t'),t('normal_s'))+
    option('data-use="heavy"','video',0,t('heavy_t'),t('heavy_s'))+'</div>';
   body.querySelectorAll('[data-use]').forEach(b=>b.addEventListener('click',()=>{S.use=b.dataset.use;show(2)}));
  }
  function step3(){
   const tr=tiers(S.days,RATE[S.use]);
   const rows=[['eco','piggy',0,'eco_t','eco_s',tr.eco,0],['calm','shield',0,'calm_t','calm_s',tr.calm,1],['free','inf',1,'free_t','free_s',tr.free,0]];
   const seen=new Set();
   body.innerHTML='<div class="wr-dh-opts">'+rows.filter(r=>r[5]&&!seen.has(r[5].key)&&seen.add(r[5].key)).map(r=>
    option('data-prio="'+r[0]+'"',r[1],r[2],t(r[3]),t(r[4]),'<span class="wr-dh-pr"><strong>'+esc(r[5].label)+'</strong><small>'+esc(money(r[5].price))+'</small></span>',r[6])).join('')+'</div>';
   body.querySelectorAll('[data-prio]').forEach(b=>b.addEventListener('click',()=>{S.prio=b.dataset.prio;show(3)}));
  }
  function step4(){
   const pk=tiers(S.days,RATE[S.use])[S.prio];
   if(!pk){show(2);return;}
   const calm=pk.unl?t('calm_free'):S.prio==='eco'?t('calm_eco'):t('calm_calm');
   body.innerHTML='<div class="wr-dh-tile"><span class="wr-dh-rib">'+esc(t('ideal'))+'</span><b>'+esc(pk.label)+'</b><small>'+esc(pk.unl?dayWord(pk.days):t('valid',{n:pk.days}))+'</small><strong>'+esc(money(pk.price))+'</strong></div>'+
    '<p class="wr-dh-calm"><i aria-hidden="true">'+I.shield+'</i><span>'+esc(calm)+'</span></p>'+
    '<button type="button" class="wr-dh-cta" data-choose>'+esc(t('choose',{pack:pk.label,price:money(pk.price)}))+'</button>'+
    '<button type="button" class="wr-dh-link" data-restart>'+esc(t('restart'))+'</button>';
   body.querySelector('[data-choose]').addEventListener('click',()=>{
    const ok=pk.unl?packs.pickUnlimited(pk.days):packs.pickLimited(pk.id);
    close();
    const target=ok&&document.querySelector(pk.unl?'#wrpaneUnl':'.wr-pp .chip.on');
    if(target)target.scrollIntoView({behavior:'smooth',block:'center'});
   });
   body.querySelector('[data-restart]').addEventListener('click',()=>show(0));
  }
  // Les questions tiennent toujours sur une ligne, à la même taille d'une étape à l'autre :
  // on prend la plus grande taille qui convient à la plus longue des quatre.
  let qSize=0;
  function fitQuestion(){
   const current=q.textContent;
   q.style.fontSize='';
   let size=parseFloat(getComputedStyle(q).fontSize)||24;
   for(const key of Q){
    q.textContent=t(key);
    while(q.scrollWidth>q.clientWidth+1&&size>14){size-=.5;q.style.fontSize=size+'px';}
   }
   q.textContent=current;qSize=size;
  }
  window.addEventListener('resize',()=>{qSize=0;if(dialog.open)fitQuestion();});
  const STEPS=[step1,step2,step3,step4],Q=['q1','q2','q3','q4'];
  function show(i,focus=true){
   S.i=i;
   bars.forEach((b,k)=>b.classList.toggle('on',k<=i));
   back.hidden=i===0;
   eyebrow.textContent=t('step',{n:i+1,total:STEPS.length});
   q.textContent=t(Q[i]);
   if(!qSize)fitQuestion();
   body.style.animation='none';void body.offsetWidth;body.style.animation='';
   STEPS[i]();
   if(focus)q.focus({preventScroll:true});
  }
  back.addEventListener('click',()=>show(Math.max(0,S.i-1)));

  /* ---- ouverture / fermeture ---- */
  let opener=null,previousOverflow='',locked=false;
  const release=()=>{if(!locked)return;locked=false;document.body.style.overflow=previousOverflow;if(opener?.isConnected)opener.focus({preventScroll:true});};
  const close=()=>{if(dialog.open)dialog.close();release();};
  triggers.forEach(button=>button.addEventListener('click',()=>{
   if(dialog.open)return;
   opener=button;previousOverflow=document.body.style.overflow;locked=true;
   dialog.showModal();document.body.style.overflow='hidden';
   qSize=0;show(0);
  }));
  dialog.querySelectorAll('[data-wr-dh-close]').forEach(b=>b.addEventListener('click',close));
  dialog.addEventListener('click',event=>{
   if(event.target!==dialog)return;
   const r=dialog.getBoundingClientRect();
   if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();
  });
  dialog.addEventListener('close',release);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(dialog))close();});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();
